import React from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';

import SelectedGroupItem from './SelectedGroupItem';

import { setSelectedGroups } from '../../ducks/feedActions';
import { alphabetizeGroups } from '../../helperFunctions';

const GroupsContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`;

const SelectedGroups = () => {
  const selectedGroups = useSelector((state) => state.feed.data.selectedGroups);

  const dispatch = useDispatch();

  const handleDeleteGroup = (groupId) => {
    const updatedGroups = selectedGroups.filter(
      (group) => group.id !== groupId,
    );
    dispatch(setSelectedGroups(updatedGroups));
  };

  const sortedGroups = alphabetizeGroups(selectedGroups);

  return (
    <GroupsContainer>
      {selectedGroups.length > 0
        && sortedGroups.map((group) => (
          <SelectedGroupItem
            key={group.id}
            group={group}
            deleteGroup={handleDeleteGroup}
          />
        ))}
    </GroupsContainer>
  );
};

export default SelectedGroups;
